import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {AddInfluencerGroup} from '../../../../models/influencer';
import {GroupService} from '../../../services/group-details/group.service';
import {InfluencerSuggestion, InfluencerSuggestionState} from '../../../../models/influencer-suggestion';
import {InfluencerGroup} from '../../../../models/influencer-group';
import {Country} from '../../../../models/country';
import {UserService} from '../../../services/user.service';
import {ModalService} from '../../../services/modal/modal.service';
import {AchooPopupComponent} from '../../../core/achoo-popup/achoo-popup.component';
import {TranslateService} from '@ngx-translate/core';
import {listOrderedPlatforms} from '../../../app.constants';
import {AutoSuggestionInfluencerComponent} from '../auto-suggestion-influencer/auto-suggestion-influencer.component';
import {InfluencerService} from '../../../services/influencer/influencer.service';
import {SendToReviewComponent} from '../../bottombar-influencer-fragement/send-to-review/send-to-review.component';
import {
  ActionSource, EventTrackerService, Page, TargetType,
  UserActionType
} from '../../../services/event-tracker/event-tracker.service';

@Component({
  selector: 'add-influencer-group',
  templateUrl: './add-influencer-group.component.html',
  styleUrls: ['./add-influencer-group.component.scss']
})
export class AddInfluencerGroupComponent implements OnInit, AfterViewInit {

  @ViewChild('WarningInfluencerAlreadyExistOtherGroup')
  warningInfluencerAlreadyExistOtherGroup: AchooPopupComponent;
  @ViewChild('ConfirmationBeforeCloseAddInfluencer')
  confirmationBeforeCloseAddInfluencer: AchooPopupComponent;
  @ViewChild('autoSuggestionInfluencer')
  autoSuggestionInfluencer: AutoSuggestionInfluencerComponent;
  @ViewChild('WarningBeforeAddNewInfluencer')
  warningForAddingNewInfluencer: AchooPopupComponent;
  @ViewChild('AddInfluencerForReview')
  addInfluencerForReview: SendToReviewComponent;

  @Input()
  public countryList: Country[];
  @Input()
  public influencerGroup: InfluencerGroup = new InfluencerGroup();
  @Input()
  public showAddInfluencerToGroupFragment: boolean | false;
  @Input()
  public alreadySelectedInfluencers: InfluencerSuggestion[];
  @Input()
  public pendingAddInfluencerToGroup: AddInfluencerGroup;
  @Output()
  public closeFragmentEvent = new EventEmitter<any>();
  @Output()
  public addInfluencerToGroupEvent = new EventEmitter<any>();
  @Output()
  public addNewInfluencerManuallyEvent = new EventEmitter<any>();

  selectedInfluencers: InfluencerSuggestion[] = [];
  public platformList: any[] = [];
  public errorMessage: string;
  public listInfluencerBelongToCurrentGroup = [];
  private reviewerList: number[] = [];
  private needToReview: boolean;

  constructor(protected groupService: GroupService,
              protected userService: UserService,
              protected translate: TranslateService,
              protected influencerService: InfluencerService,
              protected eventTracker: EventTrackerService,
              protected modalService: ModalService) {
    this.platformList = listOrderedPlatforms;
  }

  ngOnInit() {
    // don't call this API when adding influencer to campaign
    // only use when adding influencer to group
    if (this.influencerGroup.influencer_group_id) {
      this.fetchListInfluencerBelongedToGroup(this.influencerGroup.influencer_group_id);
    }

    if (this.alreadySelectedInfluencers) {
      this.selectedInfluencers.push(...this.alreadySelectedInfluencers);
    }
    if (this.pendingAddInfluencerToGroup) {
      this.reviewerList = this.pendingAddInfluencerToGroup.reviewList;
      this.needToReview = this.pendingAddInfluencerToGroup.addForReview;
    }
  }

  ngAfterViewInit() {
    if (this.pendingAddInfluencerToGroup && this.addInfluencerForReview) {
      this.addInfluencerForReview.needToReview = this.pendingAddInfluencerToGroup.addForReview;
      this.addInfluencerForReview.selectedReviewers = this.pendingAddInfluencerToGroup.reviewList ? this.pendingAddInfluencerToGroup.reviewList : [];
    }
  }

  private fetchListInfluencerBelongedToGroup(influencerGroupId) {
    this.groupService.getListInfluencerBelongToGroup(influencerGroupId).subscribe((res) => {
      if (res) {
        this.listInfluencerBelongToCurrentGroup = res.data;
      }
    });
  }

  protected validateSelectedInfluencer(influencer: InfluencerSuggestion): boolean {
    const isSelected = this.selectedInfluencers.findIndex((item) => item.influencerId === influencer.influencerId) >= 0;
    // if influencer already selected, show a warning message
    if (isSelected) {
      this.errorMessage = this.translate.instant('group_details.warning_message_influencer_already_selected');
      this.modalService.open(this.warningInfluencerAlreadyExistOtherGroup, undefined, true);
      return false;
    }
    return true;
  }

  private processAddingInfluencerToGroup(influencer: InfluencerSuggestion, influencerGroup: InfluencerGroup) {
    // For campaign, adding the influencer immediately
    if (!influencerGroup || !influencerGroup.influencer_group_id) {
      this.showAddedInfluencerToUI(influencer);
      return;
    }
    this.groupService.getListInfluencerBelongToGroup(influencerGroup.influencer_group_id).subscribe((res) => {
      if (res) {
        this.listInfluencerBelongToCurrentGroup = res.data;
        const alreadyAddedToCurrentGroup = this.listInfluencerBelongToCurrentGroup.findIndex((item) =>
          item.influencer_id === influencer.influencerId && item.influencer_group_id === influencerGroup.influencer_group_id) >= 0;

        // if influencer already added, show a warning message
        if (alreadyAddedToCurrentGroup) {
          this.errorMessage = this.translate.instant('group_details.warning_message_influencer_already_exist', {
            groupName: influencerGroup.influencer_group_name
          });
          this.modalService.open(this.warningInfluencerAlreadyExistOtherGroup, undefined, true);
          return false;
        } else {
          this.showAddedInfluencerToUI(influencer);
        }
      }
    });
  }

  private showAddedInfluencerToUI(influencer: InfluencerSuggestion) {
    const unkownInfluencer = this.selectedInfluencers.find(inf => inf.id <= 0 && influencer.channels.filter(channel => channel.handle === inf.influencerName).length > 0);
    // auto pre-fill unknown influencer by selected influencer if they have the same handle
    if (unkownInfluencer) {
      unkownInfluencer.state = InfluencerSuggestionState.SINGLE_SUGGESTION;
      unkownInfluencer.channels = influencer.channels;
      unkownInfluencer.country = influencer.country;
      unkownInfluencer.countryCode = influencer.country ? influencer.country.code : '';
      unkownInfluencer.id = influencer.id;
      unkownInfluencer.influencerId = influencer.id;
    } else {
      // push influencer as the new selection
      influencer.state = InfluencerSuggestionState.SINGLE_SUGGESTION;
      this.selectedInfluencers.push(influencer);
    }
  }

  selectInfluencerSuggestion(influencer: InfluencerSuggestion) {
    const isValidInfluencer = this.validateSelectedInfluencer(influencer);
    if (isValidInfluencer) {
      this.processAddingInfluencerToGroup(influencer, this.influencerGroup);
    }
  }

  removeInfluencer(influencerId, influencerName) {
    let deleteIndex: number | null;
    if (influencerId > 0) {
      deleteIndex = this.selectedInfluencers.findIndex((influencer: InfluencerSuggestion) => influencer.influencerId === influencerId);
    } else {
      deleteIndex = this.selectedInfluencers.findIndex((influencer: InfluencerSuggestion) => influencer.influencerName === influencerName);
    }
    if (deleteIndex >= 0) {
      this.selectedInfluencers.splice(deleteIndex, 1);
    }
  }

  onEnterInfluencer(e) {
    const unknowInfluencer: InfluencerSuggestion = new InfluencerSuggestion();
    unknowInfluencer.id = 0;
    unknowInfluencer.influencerName = e.handle;
    if (e.isLoading) {
      unknowInfluencer.state = InfluencerSuggestionState.PROCESSING;
    } else {
      this.updateStateInfluencer(unknowInfluencer, e.suggestionList);
    }
    this.selectedInfluencers.push(unknowInfluencer);
  }

  afterSearchingInfluencer(e) {
    const processingInfluencers = this.selectedInfluencers.filter(inf => inf.state === InfluencerSuggestionState.PROCESSING && inf.id === 0);
    processingInfluencers.forEach(pi => {
      if (e.hasError) {
        pi.state = InfluencerSuggestionState.ERROR;
      } else {
        this.updateStateInfluencer(pi, e.suggestionList);
      }
    });
  }

  /**
   * calculate the influencer suggestion status base on it's handle and search result
   * @param {InfluencerSuggestion} processingInfluencer
   * @param {InfluencerSuggestion[]} results
   */
  private updateStateInfluencer(processingInfluencer: InfluencerSuggestion, results: InfluencerSuggestion[]) {
    if (!results) {
      processingInfluencer.state = InfluencerSuggestionState.NOT_FOUND;
      return;
    }

    const matchedByHandle = results.filter(inf => inf.channels.filter(channel => channel.handle === processingInfluencer.influencerName).length > 0);
    if (matchedByHandle.length === 1) {
      processingInfluencer.state = InfluencerSuggestionState.SINGLE_SUGGESTION;
      processingInfluencer.channels = matchedByHandle[0].channels;
      processingInfluencer.country = matchedByHandle[0].country;
      processingInfluencer.countryCode = matchedByHandle[0].country ? matchedByHandle[0].country.code : '';
      processingInfluencer.id = matchedByHandle[0].id;
    } else if (matchedByHandle.length > 1) {
      processingInfluencer.state = InfluencerSuggestionState.MULTIPLE_SUGGESTIONS;
    } else if (matchedByHandle.length === 0) {
      processingInfluencer.state = InfluencerSuggestionState.NOT_FOUND;
    }
  }

  hasPlatform(platformId: string, influencer: InfluencerSuggestion) {
    if (!influencer.channels) {
      return false;
    }

    return influencer.channels.findIndex((channel) => channel.platform.id === platformId) >= 0;
  }

  addInfluencerToGroup() {
    const addInfluencerGroup = this.getAddInfluencerToGroupData();
    this.addInfluencerToGroupEvent.emit({
      addInfluencerGroup,
      selectedInfluencers: this.selectedInfluencers,
    });
    this.closeAddInfluencerFragment({
      resetSelectedInfluencer: false,
      isReloadInfluencerList: false
    });
  }

  private getAddInfluencerToGroupData() {
    const influencerIdList = this.selectedInfluencers.map((influencer) => influencer.influencerId);
    const addInfluencerGroup: AddInfluencerGroup = {
      influencer_group_id: this.influencerGroup.influencer_group_id,
      description: '',
      influencerGroupName: this.influencerGroup.influencer_group_name,
      influencerList: influencerIdList.filter((id) => id > 0),
      reviewList: this.reviewerList,
      addForReview: this.needToReview
    };
    return addInfluencerGroup;
  }

  closeAddInfluencerFragment(e) {
    this.closeFragmentEvent.emit(e);
    this.closeConfirmationPopup();
  }

  closeWithoutSaving(evt?) {
    this.closeAddInfluencerFragment({
      resetSelectedInfluencer: true,
      isReloadInfluencerList: evt && evt.bulkUploadInfluencers ? true : false,
      isTemporaryHidden: evt && evt.isTemporaryHidden,
      bulkUploadInfluencers: evt ? evt.bulkUploadInfluencers : null,
      influencerGroupId: this.influencerGroup.influencer_group_id
    });
  }

  isUnknownInfluencer(influencer) {
    return influencer.id <= 0;
  }

  public getCountryCode(influencer) {
    if (influencer && influencer.country && influencer.country.code) {
      return influencer.country.code.toLowerCase();
    }
    return influencer && influencer.countryCode ? influencer.countryCode.toLowerCase() : '';
  }

  public getChannels(influencer) {
    const channelName = influencer && influencer.channels && influencer.channels.length > 0 ? influencer.channels[0].handle : influencer.influencerName;
    if (!channelName) {
      return '';
    }
    return channelName.indexOf('@') >= 0 ? channelName : `@${channelName}`;
  }

  public addNewInfluencer(evt) {
    this.addNewInfluencerManuallyEvent.emit({
      handle: evt.handle,
      processingIndex: evt.index,
      influencerSuggestion: evt.influencer,
      selectedInfluencers: this.selectedInfluencers,
      pendingAddInfluencerToGroup: this.getAddInfluencerToGroupData()
    });
  }

  public selectAndAddNewInfluencer(evt) {
    // select new influencer by handle
    this.onEnterInfluencer({
      handle: evt.handle,
      suggestionList: []
    });
    const selectedInfluencer = this.selectedInfluencers.find(infl => infl.influencerName === evt.handle);
    evt.influencer = selectedInfluencer;
    // add new influencer
    this.addNewInfluencer(evt);
  }

  public validateInfluencerListBeforeAddToGroup() {
    const incompletedInfluencers = this.selectedInfluencers.filter(infl => infl.state === InfluencerSuggestionState.NOT_FOUND);
    if (incompletedInfluencers.length > 0) {
      this.modalService.openInCenter(this.warningForAddingNewInfluencer);
    } else {
      this.addInfluencerToGroup();
    }
  }

  public retryWhenErrorOccurred(evt) {
    // if an error occurred when loading influencer suggestion. Try to reload again
    if (this.autoSuggestionInfluencer.hasErrorWhenSearching) {
      this.autoSuggestionInfluencer.openSuggestionDropdown(evt.influencer.influencerName, false);
    } else if (this.influencerService.invalidNewInfluencer) {
      // when error occurred when call API to add new influencer. Try to add it again
      const newInfluencer = this.influencerService.invalidNewInfluencer.newInfluencer;
      const influencerChannels = this.influencerService.invalidNewInfluencer.influencerChannels;
      const processingInfluencer = this.selectedInfluencers[evt.index];
      processingInfluencer.state = InfluencerSuggestionState.PROCESSING;
      this.influencerService.addNewInfluencer(newInfluencer, influencerChannels,
        (influencer) => {
          this.influencerService.clearInvalidInfluencerData();
          if (processingInfluencer) {
            processingInfluencer.id = influencer.id;
            processingInfluencer.influencerId = influencer.id;
            processingInfluencer.channels = influencerChannels.map(c => ({
              platform_id: c.platform_id,
              handle: c.handle
            }));
            processingInfluencer.influencerName = influencer.domain;
            processingInfluencer.countryCode = influencer.country.code;
            processingInfluencer.state = InfluencerSuggestionState.SINGLE_SUGGESTION;
          }
        }, () => {
          processingInfluencer.state = InfluencerSuggestionState.ERROR;
        });
    }
  }


  public openMultipleHandleSelection(evt) {
    this.autoSuggestionInfluencer.openSuggestionDropdown(evt);
  }

  get canProceedNewInfluencer(): boolean {
    return this.selectedInfluencers.filter(inf =>
      inf.state === InfluencerSuggestionState.PROCESSING || inf.state === InfluencerSuggestionState.ERROR).length === 0;
  }

  closeConfirmationPopup() {
    this.modalService.close();
  }

  openConfirmationBeforeExisting() {
    if (this.selectedInfluencers.length > 0) {
      this.modalService.openInCenter(this.confirmationBeforeCloseAddInfluencer);
    } else {
      this.closeAddInfluencerFragment({
        resetSelectedInfluencer: true,
        isReloadInfluencerList: false
      });
    }
  }

  onChangeSelectedReviewers(evt) {
    this.reviewerList = evt.selectedReviewers;
    this.needToReview = evt.addForReview;
    if (evt.needToSendMPEvent) {
      this.sendMPEventWhenChangingReviewer();
    }
  }
  private sendMPEventWhenChangingReviewer() {
    this.eventTracker.trackUserAction(UserActionType.ACTION, Page.INFLUENCER_GROUP, {
      id: this.influencerGroup.influencer_group_id,
      name: this.influencerGroup.influencer_group_name,
      type: TargetType.REQUEST_REVIEW
    }, {
      action: UserActionType.TOGGLE,
      source: ActionSource.ACTION_VIEW
    });
  }

  get hasSelectedInfluencers() {
    return this.selectedInfluencers.length > 0;
  }

}



// WEBPACK FOOTER //
// ./src/app/main/group-details/add-influencer-group/add-influencer-group.component.ts